import "./index.scss";
import Image from "next/image";

export default function About() {
  return (
    <>
      {/* About Section */}
      <section id="about" className="about-area py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="about-inner flex gap-16 items-center">
            <div className="w-1/3">
              <div className="flex items-center justify-center">
                <Image
                  width={250}
                  height={200}
                  className=""
                  src="/shared/cateringNationwideLogo.jpg"
                  alt="About"
                />
              </div>
              <p className="mt-4 mb-6 text-center text-[17px] leading-6">
                Provide catering with the rich flavors of India for every
                occasion. Specializes in
                <span className="font-semibold">
                  Tray orders, Private events & large group gatherings.
                </span>
              </p>
            </div>
            <div className="w-1/3 flex justify-center">
              <div className="relative center-img mb-6">
                <Image
                  width={400}
                  height={600}
                  className="pt-5 rounded-lg shadow-lg max-w-md"
                  src="/shared/cateringNationWide.jpg"
                  alt="CateringNationWide"
                />
              </div>
            </div>
            <div className="w-1/3 tabla-about-catering">
              <h2 className="text-red-800 text-2xl font-bold leading-8">
                Tabla Indian Food Catering for All Events & Occasions
              </h2>
              <p className="mt-3 text-[14px] leading-6">
                Tabla Cuisine provides the best Indian catering services in
                Orlando, FL. We help to transform your celebrations into
                unforgettable life experiences. We can cater to all your
                occasions, whether a wedding, anniversary, birthday or corporate
                event, per your dietary requirements at affordable rates. We
                specialize in Indian, Indo-Chinese, Thai, Asian Fusion, and
                Regional Indian food. Our Passionate team from multicultural
                backgrounds work tirelessly to put in a lot of effort to ensure
                that every small detail is followed throughout all stages of
                your event.
              </p>
              <p className="mt-3 text-[14px] leading-6">
                At Tabla Indian Restaurant, you will find delicacies from all
                over India on our carefully designed menu. Contact us today to
                discuss how we can make your next event a culinary success –
                We’d love nothing more than to share our food with your guests.
              </p>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}